// ResetPasswordModal.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPasswordModal = ({ show, onClose }) => {
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [dob, setDob] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const normalizeDob = (val) => {
    if (!val) return "";
    const d = new Date(val);
    if (!isNaN(d)) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }
    return val;
  };

  // Handle reset password submit
  const handleReset = async (e) => {
    e.preventDefault();

    // validations
    if (!newPass || !confirmPass || !nationalId || !dob) {
      alert("All fields are required.");
      return;
    }
    if (newPass !== confirmPass) {
      alert("Passwords do not match!");
      return;
    }

    const email = localStorage.getItem("reset_email");
    const token = localStorage.getItem("reset_token");

    if (!email || !token) {
      alert('Reset session expired. Please start again from "Forgot Password".');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email,
        token,
        password: newPass,
        password_confirmation: confirmPass,
        national_id: nationalId,
        dob: normalizeDob(dob),
      };

      await axios.post(
        "https://laravel.topdevit.com/api/reset-password",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Password updated successfully! Please login.");
      localStorage.removeItem("reset_email");
      localStorage.removeItem("reset_token");
      onClose();
      navigate("/");
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Invalid details, please try again.";
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
     <>
   <style>{`
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}
`}</style>
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Reset Password</h3>
        <form onSubmit={handleReset}>
          <div className="mb-3">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>National ID</label>
            <input
              type="text"
              className="form-control"
              value={nationalId}
              onChange={(e) => setNationalId(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Date of Birth</label>
            <input
              type="date"
              className="form-control"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
            />
          </div>
          <button className="btn btn-outline-primary" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>
          <button
            className="btn btn-outline-danger ms-2"
            type="button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ResetPasswordModal;
